import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Injector, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { InputTypes } from '../../common';
import { ErrorValidationMessageComponent } from '../error-validation-message/error-validation-message.component';
import { LayoutService } from 'src/app/core/helper';
import { MatIconModule } from '@angular/material/icon'
import { _MatAutocompleteBase, MatAutocompleteModule } from '@angular/material/autocomplete';

@Component({
  selector: 'app-input-field',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, ErrorValidationMessageComponent, MatIconModule, MatAutocompleteModule],
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputFieldComponent), multi: true }],
})
export class InputFieldComponent implements OnInit, ControlValueAccessor {
  form!: FormGroup;
  onTouched: any;
  formControl: AbstractControl;
  onChanged: (value: string) => {};
  @Input() label: string;
  @Input() inputType: InputTypes = InputTypes.TEXT;
  @Input() max: number;
  @Input() min: number;
  @Input() placeholder: string = "";
  @Input() autocomplete: string = 'new-password';

  //outputs
  @Output() inputEvent: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() focusEvent: EventEmitter<Event> = new EventEmitter<Event>();

  // getters
  get input(): AbstractControl {
    return this.form.get('input');
  }
  constructor(protected injector: Injector, protected layoutService: LayoutService) {}

  // hooks
  ngOnInit(): void {
    this.initializeForm();
    this.getFormControl();
  }

  // publics
  onInput(event: Event): void {
    this.onChanged(event.target?.['value']);
    this.inputEvent.emit(event);
  }
  
  onTouchInput(event: Event): void {
    this.onTouched();
    this.focusEvent.emit(event);
  }

  // control accessor methods
  writeValue(value: string): void {
    this.input.setValue(value);
  }
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.input.disable();
    } else {
      this.input.enable();
    }
  }

  // privates
  private initializeForm(): void {
    this.form = new FormGroup({
      input: new FormControl(),
    });
  }

  private getFormControl(): void {
    const ngControl: NgControl = this.injector.get(NgControl);
    const formDirective : FormGroupDirective = this.injector.get(FormGroupDirective);
    const controlName = ngControl.name;
    this.formControl = formDirective.form.controls[controlName];
  }
}
